import { styled, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

export const AdminBookingsPopoverInner = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  padding: 20,
});

export const AdminBookingsPopoverText = styled(Typography)({
  padding: 0,
  textAlign: 'left',
});

export const AdminBookingsDatagrid = styled(DataGrid)({
  minHeight: '200px',
  height: '670px !impotrant',
  alignSelf: 'flex-start',
  width: '100%',
  '.MuiDataGrid-cell': { border: 'none' },
});

export const AdminBookingsInterval = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',

  span: {
    lineHeight: '1.1',
  },
});

interface BookingStatusRoundProps {
  bgColor: string;
  topBorderRadius?: boolean;
  bottomBorderRadius?: boolean;
  differentUserNextBooking?: boolean;
}

export const AdminBookingItem = styled('div')<BookingStatusRoundProps>(
  ({ bgColor, topBorderRadius, bottomBorderRadius, differentUserNextBooking }) => ({
    backgroundColor: bgColor,
    width: '100%',
    height: '100%',
    borderTopLeftRadius: topBorderRadius ? undefined : 10,
    borderTopRightRadius: topBorderRadius ? undefined : 10,
    borderBottomLeftRadius: bottomBorderRadius ? undefined : 10,
    borderBottomRightRadius: bottomBorderRadius ? undefined : 10,

    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    color: 'white',
    paddingLeft: 30,

    borderBottom: differentUserNextBooking ? '1px solid white' : undefined,
  }),
);
